"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var universalCookies_1 = require("./universalCookies");
var getWindowLocationPath_1 = require("./getWindowLocationPath");
function getDefaultAnchorMailboxCookie() {
    var serverRedirect = universalCookies_1.getCookie('targetServer');
    var anchorMailboxCookieName = 'DefaultAnchorMailbox' + (serverRedirect ? '_' + serverRedirect.toLocaleLowerCase() : '');
    var anchorMailboxCookie = universalCookies_1.getCookie(anchorMailboxCookieName);
    return anchorMailboxCookie;
}
exports.getDefaultAnchorMailboxCookie = getDefaultAnchorMailboxCookie;
function getAnchorMailboxHeaderForExplicitLogon() {
    var header = "";
    // see if this is an explicit logon scenario, where the target mailbox is specified in the path
    // e.g., /mail/user@contoso.com/inbox/
    var path = getWindowLocationPath_1.default();
    var segments = path.split('/').filter(function (part) { return part.length; });
    if (segments.length >= 2) {
        if (segments[1].match(/.+@.+/)) {
            header = segments[1];
        }
    }
    return header;
}
exports.getAnchorMailboxHeaderForExplicitLogon = getAnchorMailboxHeaderForExplicitLogon;
function getAnchorMailboxHeader() {
    var header = getAnchorMailboxHeaderForExplicitLogon();
    // if there is no target in the URI, we assume the authenticated user in the default anchor mailbox cookie is the target
    if (!header) {
        header = getDefaultAnchorMailboxCookie();
    }
    return header;
}
exports.getAnchorMailboxHeader = getAnchorMailboxHeader;
